import moment from 'moment-timezone'
import { useEffect } from 'react'
import { useTimer } from 'react-timer-hook'

import { commonIcons } from '@apps-common/config/icons'
import { ICloudReceiverModel } from '@apps-common/types/portal/cloud-receiver'

interface IProps {
  data: ICloudReceiverModel | undefined
  loading: boolean
  refetch: () => void
}

export const ReceiversRefetch: React.FC<IProps> = ({ data, loading, refetch }) => {
  const { seconds, isRunning, pause, restart } = useTimer({
    expiryTimestamp: moment().add(600, 'second').toDate(),
    onExpire: () => {
      refetch()
    }
  })

  useEffect(() => {
    if (data && !loading) {
      const timestamps = (data.gateways || []).map((g) => g.timeStamp).sort()
      let timerSeconds = 30

      if (timestamps.length > 0) {
        const t = moment().diff(moment(timestamps[0]), 'seconds')

        if (60 - t < 15) {
          timerSeconds = 15
        } else {
          timerSeconds = t
        }
      }

      restart(moment().add(timerSeconds, 'second').toDate())
    }

    return () => {
      pause()
    }
  }, [data, loading])

  const Icon = commonIcons.refresh

  return (
    <button type='button' className='flex' onClick={() => refetch()}>
      <div className='flex items-center justify-between bg-surface border border-border px-2 py-1 rounded-xl min-w-[135px]'>
        {loading && (
          <div key='receivers-refetch-loading' className='flex items-center justify-start gap-[7.5px]'>
            <div className='relative h-[10px] w-[10px]'>
              <div className='absolute top-0 left-0 w-[10px] h-[10px] rounded-[5px] bg-warning' />
            </div>
            <span className='text-[0.8em] text-text'>loading...</span>
          </div>
        )}
        {!isRunning && !loading && (
          <div key='receivers-refetch-paused' className='flex items-center justify-start gap-[7.5px]'>
            <div className='relative h-[10px] w-[10px]'>
              <div className='absolute top-0 left-0 w-[10px] h-[10px] rounded-[5px] bg-error' />
            </div>
            <span className='text-[0.8em] text-text'>Paused</span>
          </div>
        )}
        {isRunning && !loading && (
          <div key='receivers-refetch-refresh-in' className='flex items-center justify-start gap-[7.5px]'>
            <div className='relative h-[10px] w-[10px]'>
              <div className='animate-ping absolute top-0 left-0 w-[10px] h-[10px] rounded-[5px] bg-success' />
              <div className='absolute top-0 left-0 w-[10px] h-[10px] rounded-[5px] bg-success' />
            </div>
            <span className='text-[0.8em] text-text'>Refresh in {seconds.toString().padStart(2, '0')}s</span>
          </div>
        )}
        <Icon className='relative top-[-1px] text-[15px]' />
      </div>
    </button>
  )
}
